const container = document.querySelector(".rttsml-slides");
if (container && container instanceof HTMLDivElement) {
	void import("./front/index.js").then(({ mountTestimonials }) => {
		mountTestimonials(container);
	});
}
